<template>
    <div>
        <process-instance :definition-id="1"></process-instance>
    </div>
</template>
<script>
    import ProcessInstance from "../components/ProcessInstance";

    export default {
        components: {ProcessInstance},
        data() {
            return {}
        }
    }

</script>